import { forwardRef, type Ref, type SVGProps } from "react";

function SvgArrowUp(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.667 6.667 8 2.333m0 0 4.333 4.334M8 2.333v11.334"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgArrowUp);
export default ForwardRef;
